import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Image from '../../atoms/Image/Image'
import aboutImage from '../../../assets/images/about-car.jpg'
import InnerBanner from '../../molecules/InnerBanner/InnerBanner'
import aboutInfo from '../../../assets/images/aboutInfo.jpg'
import aboutInfoOne from '../../../assets/images/aboutInfo1.jpg'
import aboutInfoTwo from '../../../assets/images/aboutInfo2.jpg'
import aboutInfoThree from '../../../assets/images/aboutInfo3.jpg'
const About = () => {
  return (
    <>

      <InnerBanner
        title="Who we are"
        subtitle="The Europcar Story"
        imageSrc={aboutImage}
        imageAlt="About Banner"
      />
      <section className='about-section section-padding'>
        <Container>
          <Row className='about-section--row'>
            <Col className='col-12 col-lg-6 mb-3 mb-lg-0'>
              <Image src={aboutInfo} alt='aboutInfo' width="1000" height="800" />
            </Col>
            <Col className='col-12 col-lg-6 mb-3 mb-lg-0'>
              <div className='about-section--row-item'>
                <h2 className='h3'>Redefining Mobility for Billions</h2>
                <p>Europcar are committed to providing high-quality vehicles to customers throughout Africa and its nearby countries. With years of experience in the automotive industry, our team offers a wide selection of vehicles to meet the diverse needs of our customers, from hatchbacks and sedans to SUVs and pickup trucks. We work with trusted manufacturers and suppliers to ensure that our inventory meets the highest standards of quality and reliability. </p>
                <div className='about-section--row-item-vission'>
                  <h3 className='h4'>Our Vision</h3>
                  <p>Our vision at Europcar is to be the most trusted and preferred provider of high-quality vehicles and exceptional service in the African market. We aim to deliver a seamless and hassle-free car buying experience that exceeds our customers' expectations</p>
                </div>
                <div className='about-section--row-item-vission'>
                  <h3 className='h4'>Our Mission</h3>
                  <p>To provide our customers with the highest quality vehicles and exceptional car rental service. We are committed to helping our customers find the perfect car to meet their needs and budget while delivering a seamless and hassle-free car buying experience.</p>
                </div>
              </div>
            </Col>
          </Row>

        </Container>
      </section>
      
      <section className='about-information-section section-padding-bottom'>
        <Container>
          <Row >
            <Col className='col-12 col-lg-6 mb-4 mb-lg-0'>
              <figure className='mb-0 about-information-section--image'>
                <Image src={aboutInfoOne} alt="aboutInfoOne" width="1000" height="800" />
              </figure>
            </Col>
            <Col className='col-12 col-lg-6'>
              <Row className='g-0'>
                <Col className='col-12 mb-4'>
                  <figure className='mb-0 about-information-section--image'>
                    <Image src={aboutInfoTwo} alt="aboutInfoTwo" width="1000" height="450" />
                  </figure>
                </Col>
                <Col className='col-12'>
                  <figure className='mb-0 about-information-section--image'>
                    <Image src={aboutInfoThree} alt="aboutInfoThree" width="1000" height="310" />
                  </figure>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

    </>
  )
}

export default About
